// src/controllers/content_loader_controller.js
import { Controller } from "@hotwired/stimulus";

/**
 * Stimulus controller for loading and auto-refreshing remote content into an element.
 * Fetches HTML from a URL and injects it into the controller's element.
 */
export default class extends Controller {
  static values = { url: String, refreshInterval: Number }

  /**
   * Called when the controller is connected to the DOM.
   * Loads content immediately and starts auto-refresh if configured.
   */
  connect() {
    this.load()

    if (this.hasRefreshIntervalValue) {
      this.startRefreshing()
    }
  }

  /**
   * Called when the controller is disconnected from the DOM.
   * Stops any running refresh interval.
   */
  disconnect() {
    this.stopRefreshing()
  }

  /**
   * Loads content from the configured URL and injects it into the element.
   * Uses fetch and expects HTML response.
   */
  load() {
    fetch(this.urlValue)
      .then(response => response.text())
      .then(html => this.element.innerHTML = html)
  }

  /**
   * Starts a timer to refresh content at the configured interval (ms).
   */
  startRefreshing() {
    this.refreshTimer = setInterval(() => {
      this.load()
    }, this.refreshIntervalValue)
  }

  /**
   * Stops the refresh timer if running.
   */
  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }
}
